module.exports = __webpack_public_path__ + "img/demo2.03ab6775.png";